export default __webpack_public_path__ + "static/media/catering.984d7683.jpg";